/**
 * DEVELOPER DOCUMENTATION
 *
 * Include your custom JavaScript here.
 *
 * The theme Focal has been developed to be easily extensible through the usage of a lot of different JavaScript
 * events, as well as the usage of custom elements (https://developers.google.com/web/fundamentals/web-components/customelements)
 * to easily extend the theme and re-use the theme infrastructure for your own code.
 *
 * The technical documentation is summarized here.
 *
 * ------------------------------------------------------------------------------------------------------------
 * BEING NOTIFIED WHEN A VARIANT HAS CHANGED
 * ------------------------------------------------------------------------------------------------------------
 *
 * This event is fired whenever a the user has changed the variant in a selector. The target get you the form
 * that triggered this event.
 *
 * Example:
 *
 * document.addEventListener('variant:changed', function(event) {
 *   let variant = event.detail.variant; // Gives you access to the whole variant details
 *   let form = event.target;
 * });
 *
 * ------------------------------------------------------------------------------------------------------------
 * MANUALLY CHANGE A VARIANT
 * ------------------------------------------------------------------------------------------------------------
 *
 * You may want to manually change the variant, and let the theme automatically adjust all the selectors. To do
 * that, you can get the DOM element of type "<product-variants>", and call the selectVariant method on it with
 * the variant ID.
 *
 * Example:
 *
 * const productVariantElement = document.querySelector('product-variants');
 * productVariantElement.selectVariant(12345);
 *
 * ------------------------------------------------------------------------------------------------------------
 * BEING NOTIFIED WHEN A NEW VARIANT IS ADDED TO THE CART
 * ------------------------------------------------------------------------------------------------------------
 *
 * This event is fired whenever a variant is added to the cart through a form selector (product page, quick
 * view...). This event DOES NOT include any change done through the cart on an existing variant. For that,
 * please refer to the "cart:updated" event.
 *
 * Example:
 *
 * document.addEventListener('variant:added', function(event) {
 *   var variant = event.detail.variant; // Get the variant that was added
 * });
 *
 * ------------------------------------------------------------------------------------------------------------
 * BEING NOTIFIED WHEN THE CART CONTENT HAS CHANGED
 * ------------------------------------------------------------------------------------------------------------
 *
 * This event is fired whenever the cart content has changed (if the quantity of a variant has changed, if a variant
 * has been removed, if the note has changed...). This event will also be emitted when a new variant has been
 * added (so you will receive both "variant:added" and "cart:updated"). Contrary to the variant:added event,
 * this event will give you the complete details of the cart.
 *
 * Example:
 *
 * document.addEventListener('cart:updated', function(event) {
 *   var cart = event.detail.cart; // Get the updated content of the cart
 * });
 *
 * ------------------------------------------------------------------------------------------------------------
 * REFRESH THE CART/MINI-CART
 * ------------------------------------------------------------------------------------------------------------
 *
 * If you are adding variants to the cart and would like to instruct the theme to re-render the cart, you cart
 * send the cart:refresh event, as shown below:
 *
 * document.documentElement.dispatchEvent(new CustomEvent('cart:refresh', {
 *   bubbles: true
 * }));
 *
 * ------------------------------------------------------------------------------------------------------------
 * USAGE OF CUSTOM ELEMENTS
 * ------------------------------------------------------------------------------------------------------------
 *
 * Our theme makes extensive use of HTML custom elements. Custom elements are an awesome way to extend HTML
 * by creating new elements that carry their own JavaScript for adding new behavior. The theme uses a large
 * number of custom elements, but the two most useful are drawer and popover. Each of those components add
 * a "open" attribute that you can toggle on and off. For instance, let's say you would like to open the cart
 * drawer, whose id is "mini-cart", you simply need to retrieve it and set its "open" attribute to true (or
 * false to close it):
 *
 * document.getElementById('mini-cart').open = true;
 *
 * Thanks to the power of custom elements, the theme will take care automagically of trapping focus, maintaining
 * proper accessibility attributes...
 *
 * If you would like to create your own drawer, you can re-use the <drawer-content> content. Here is a simple
 * example:
 *
 * // Make sure you add "aria-controls", "aria-expanded" and "is" HTML attributes to your button:
 * <button type="button" is="toggle-button" aria-controls="id-of-drawer" aria-expanded="false">Open drawer</button>
 *
 * <drawer-content id="id-of-drawer">
 *   Your content
 * </drawer-content>
 *
 * The nice thing with custom elements is that you do not actually need to instantiate JavaScript yourself: this
 * is done automatically as soon as the element is inserted to the DOM.
 *
 * ------------------------------------------------------------------------------------------------------------
 * THEME DEPENDENCIES
 * ------------------------------------------------------------------------------------------------------------
 *
 * While the theme tries to keep outside dependencies as small as possible, the theme still uses third-party code
 * to power some of its features. Here is the list of all dependencies:
 *
 * "vendor.js":
 *
 * The vendor.js contains required dependencies. This file is loaded in parallel of the theme file.
 *
 * - custom-elements polyfill (used for built-in elements on Safari - v1.0.0): https://github.com/ungap/custom-elements
 * - web-animations-polyfill (used for polyfilling WebAnimations on Safari 12, this polyfill will be removed in 1 year - v2.3.2): https://github.com/web-animations/web-animations-js
 * - instant-page (v5.1.0): https://github.com/instantpage/instant.page
 * - tocca (v2.0.9); https://github.com/GianlucaGuarini/Tocca.js/
 * - seamless-scroll-polyfill (v2.0.0): https://github.com/magic-akari/seamless-scroll-polyfill
 *
 * "flickity.js": v2.2.0 (with the "fade" package). Flickity is only loaded on demand if there is a product image
 * carousel on the page. Otherwise it is not loaded.
 *
 * "photoswipe": v4.1.3. PhotoSwipe is only loaded on demand to power the zoom feature on product page. If the zoom
 * feature is disabled, then this script is never loaded.
 */
 function chatShow() {
  window.tidioChatApi.show();
  window.tidioChatApi.open();
}


$(document).ready(function (){

//   $('.slider-content').slick({
//   slidesToShow: 1,
//   slidesToScroll: 1,
//   arrows: true,
//   fade: false,
// 	infinite: false,
// 	speed: 1000,
//   asNavFor: '.slider-thumb',
//     arrows: true,
//     prevArrow: '<button type="button" data-role="none" class="slick-prev" aria-label="Previous" tabindex="0" role="button">Previous</button>',
//     nextArrow: '<button type="button" data-role="none" class="slick-next" aria-label="Next" tabindex="0" role="button">Next</button>',
// });
$('.slider-thumb').slick({
  slidesToShow: 1,
  slidesToScroll: 1,
  dots: false,
  centerMode: false,
  focusOnSelect: true,
	prevArrow: '<button type="button" data-role="none" class="slick-prev" aria-label="Previous" tabindex="0" role="button">Previous</button>',
    nextArrow: '<button type="button" data-role="none" class="slick-next" aria-label="Next" tabindex="0" role="button">Next</button>'
});
  $('.slider-collections').slick({
  slidesToShow: 3,
  slidesToScroll: 3,
  dots: false,
  centerMode: false,
  focusOnSelect: true,
	prevArrow: '<button type="button" data-role="none" class="slick-prev" aria-label="Previous" tabindex="0" role="button">Previous</button>',
    nextArrow: '<button type="button" data-role="none" class="slick-next" aria-label="Next" tabindex="0" role="button">Next</button>'
});
setTimeout(function() {
  $('.cstm-reccomands').each(function (k, v) {
   $('.cstm-reccomands'+ k).slick({
    infinite: false,
    slidesToShow: 1,
    arrows: true,
    slidesToScroll: 1,
    dots: false,
     prevArrow: '<button type="button" data-role="none" class="slick-prev" aria-label="Previous" tabindex="0" role="button">Previous</button>',
    nextArrow: '<button type="button" data-role="none" class="slick-next" aria-label="Next" tabindex="0" role="button">Next</button>'
   });
  })
}, 1000);

});
// $(document).on('click','.recents-btn', function (){
//   var _this = $('li.recent-post.active');    
//   if ($(this).hasClass('next') && _this.next('li.recent-post'))
//         _this.hide().removeClass('active').next('li.recent-post').addClass('active').show();
//   else if($(this).hasClass('prev') && _this.prev('li.recent-post'))
//     _this.hide().removeClass('active').prev('li.recent-post').addClass('active').show();
// });
	
// $(document).on('click','.footer__item.footer__item--links p.footer__item-title', function (){
//  if ($(window).width() < 480) {
//      $(this).toggleClass('active');
//          $(this).siblings('.footer__item-content').slideToggle();
//  }
// })

// $(document).on('click','.recents-btn', function (){
//   var _this = $('ul li.recent-post.active');    
//   if ($(this).hasClass('next') && _this.last().index() != _this.index())
//         _this.hide().removeClass('active').next('li.recent-post').addClass('active').show();
//   else if($(this).hasClass('prev') && _this.first().index() == 1 )
//     _this.hide().removeClass('active').prev('li.recent-post').addClass('active').show();
// })
  $(document).on('click',".video-control", function() {
  // var indexx = $('video').data('min');
   var video =  $('video').get(0);
      if ( video.paused ) {
        $('video').trigger('play');
      } else {
          // video.pause();
      $('video').trigger('pause');   
      }
  
      return false;
  });
  
  function onScroll(event){
    var scrollPos = $(document).scrollTop();
    $('#menu-center a').each(function () {
        var currLink = $(this);
        var refElement = $(currLink.attr("href"));
        if (refElement.position().top <= scrollPos && refElement.position().top + refElement.height() > scrollPos) {
            $('#menu-center ul li a').removeClass("active");
            currLink.addClass("active");
        }
        else{
            currLink.removeClass("active");
        }
    });
}
  $(document).ready(function () {
    // $(document).on("scroll", onScroll);
    
    //smoothscroll
    $('a[href^="#"]').on('click', function (e) {
        e.preventDefault();
        $(document).off("scroll");
        
        $('a').each(function () {
            $(this).removeClass('active');
        })
        $(this).addClass('active');
      
        var target = this.hash,
            menu = target;
        $target = $(target);
        $('html, body').stop().animate({
            'scrollTop': $target.offset().top+2
        }, 1500, 'swing', function () {
            window.location.hash = target;
            $(document).on("scroll", onScroll);
        });
    });
});

$(document).on('click', 'recently-viewed-products .remove-button',function (){
    var strarr = JSON.parse(localStorage.getItem('theme:recently-viewed-products'));
    var productId = $(this).data('product');
    var newArr = []; 
    $.each(strarr, function (key, value){
        if(productId != value){
         newArr.push(value);
        }
    })
      var temp = JSON.stringify(newArr);

    if(newArr.length == 0){
      localStorage.removeItem('theme:recently-viewed-products');       
      $('recently-viewed-products').hide();
    }else if(newArr.length < 5){
    $('recently-viewed-products prev-next-buttons').hide();  
    localStorage.setItem('theme:recently-viewed-products', temp);
       $('recently-viewed-products').show();
       $(this).closest('.product-item').remove();
    }
      else{
      
      localStorage.setItem('theme:recently-viewed-products', temp);
       $('recently-viewed-products').show();
        $(this).closest('.product-item').remove();
    }
    // console.log('productId : ', productId ,' MyStringArray : ', strarr, 'newarray : ',newArr);
    })

$(document).on('click', 'button.combo-box__option-item.material', function (){
     var temp = $(this).text().trim();
      var str = temp.split(' ');
      // console.log('str : ',str[0]);
  if(str[0] == 950 ){
      $('.metal_swatch').fadeOut();
      // console.log('stest')
  }
  else{
      // console.log('fadein text')
          $('.metal_swatch').fadeIn();
  
  } 
})

 $(window).on('load', function () {
    var temp = $('select.cstom-variant.material option:selected').val();
    var str = temp.split(' ');
    if(str[0] == 950 ){
        $('.metal_swatch').fadeOut();
    }
    else{
            $('.metal_swatch').fadeIn();
    }
 });
$(document).on('click', '.block-swatch label.block-swatch__item', function (){
     var temp = $(this).text().trim();
      var str = temp.split(' ');
      // console.log('str : ',str[0]);
  if(str[0] == 950 ){
      $('.drawer__content  .metal_swatch').fadeOut();
      // console.log('stest')
  }
  else{
      // console.log('fadein text')
          $('.drawer__content  .metal_swatch').fadeIn();
  
  } 
})

